import apiClient from './api';

class AzureDataFactoryService {
  async getStatus() {
    const response = await apiClient.get('/azure-datafactory/status');
    return response.data?.data || response.data;
  }

  async listPipelines() {
    const response = await apiClient.get('/azure-datafactory/pipelines');
    return response.data?.data || response.data;
  }

  async getPipelineTree() {
    const response = await apiClient.get('/azure-datafactory/pipelines/tree');
    return response.data?.data || response.data;
  }

  async triggerPipeline(pipelineName, parameters = {}) {
    const response = await apiClient.post(
      `/azure-datafactory/pipelines/${encodeURIComponent(pipelineName)}/trigger`,
      { parameters }
    );
    return response.data?.data || response.data;
  }

  async getPipelineRuns({ dateFrom, dateTo, status, pipelineName } = {}) {
    const params = new URLSearchParams();
    if (dateFrom) params.append('dateFrom', dateFrom);
    if (dateTo) params.append('dateTo', dateTo);
    if (status) params.append('status', status);
    if (pipelineName) params.append('pipelineName', pipelineName);
    const response = await apiClient.get(`/azure-datafactory/runs?${params.toString()}`);
    return response.data?.data || response.data;
  }

  async getRunStatus(runId) {
    const response = await apiClient.get(`/azure-datafactory/runs/${runId}`);
    return response.data?.data || response.data;
  }

  async getRunActivities(runId) {
    const response = await apiClient.get(`/azure-datafactory/runs/${runId}/activities`);
    return response.data?.data || response.data;
  }

  async cancelRun(runId) {
    const response = await apiClient.post(`/azure-datafactory/runs/${runId}/cancel`);
    return response.data?.data || response.data;
  }
}

export default new AzureDataFactoryService();
